import { CommonBindingDataService } from './../../services/common-binding-data.service';
import { Component, OnInit, Input} from '@angular/core';


@Component({
    selector: 'app-autocomplete-search',
    templateUrl: './autocomplete-search.component.html',
    standalone: false
})
export class AutocompleteSearchComponent implements OnInit {
  searchTextResult: any[] = [];
  @Input() searchUrl = '/secure/drivers/nearbydriver/search';
  @Input() queryArray;
  @Input() placeHolderText = '';

  constructor(private commonBindingDataService: CommonBindingDataService) { }

  ngOnInit() {

  }

  search(event) {
    const searchText = event.query;
    this.commonBindingDataService.searchAutocomplete(this.getSearchUrl(searchText))
      .subscribe(searchList => {
        if (searchList != null) {
          const c = this;
          this.searchTextResult = [];
          searchList.forEach(e => {
            c.searchTextResult.push({
              name: e.firstName + ' ' + e.lastName,
              id: e.driverId,
              referrenceNumber: e.referrenceNumber,
              eta: e.eta
            });
          });
        }
      });
  }

  getSearchUrl(searchText) {
    let url;
    if (this.queryArray.length <= 0) {
      url = 'searchText=' + searchText;
    } else {
      url = this.generateQueryString() + 'searchText=' + searchText;
    }
    return this.searchUrl + '?' + url;
  }

  generateQueryString() {
    let queryUrl = '';
    for (const obj of this.queryArray) {
      queryUrl += obj.key + '=' + obj.value + '&';
    }
    return queryUrl;
  }

}
